var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
export var CountingButtonStyleType;
(function (CountingButtonStyleType) {
    CountingButtonStyleType[CountingButtonStyleType["Increment"] = 0] = "Increment";
    CountingButtonStyleType[CountingButtonStyleType["Decrement"] = 1] = "Decrement";
})(CountingButtonStyleType || (CountingButtonStyleType = {}));
var StyledCountingButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background: ", ";\n  border: 2px solid ", ";\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n  display: block;\n  padding: 0;\n  cursor: pointer;\n"], ["\n  position: relative;\n  background: ", ";\n  border: 2px solid ", ";\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n  display: block;\n  padding: 0;\n  cursor: pointer;\n"])), function (props) { return props.theme.colors.background; }, function (props) { return props.theme.colors.secondary; });
var StyledHorizontalPlus = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n  width: 50%;\n  height: 12.5%;\n  left: 25%;\n  top: 43.75%;\n"], ["\n  position: relative;\n  background-color: ", ";\n  width: 50%;\n  height: 12.5%;\n  left: 25%;\n  top: 43.75%;\n"])), function (props) { return props.theme.colors.primary; });
var StyledVerticalPlus = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n  width: 12.5%;\n  height: 50%;\n  left: 43.75%;\n  top: 12.5%;\n"], ["\n  position: relative;\n  background-color: ", ";\n  width: 12.5%;\n  height: 50%;\n  left: 43.75%;\n  top: 12.5%;\n"])), function (props) { return props.theme.colors.primary; });
var StyledIconContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n"], ["\n  height: 100%;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n"])));
function CountingButton(_a) {
    var _b = _a.styleType, styleType = _b === void 0 ? CountingButtonStyleType.Increment : _b, props = __rest(_a, ["styleType"]);
    var icon = (React.createElement(StyledIconContainer, null,
        React.createElement(StyledHorizontalPlus, null)));
    if (styleType === CountingButtonStyleType.Increment) {
        icon = (React.createElement(StyledIconContainer, null,
            React.createElement(StyledHorizontalPlus, null),
            React.createElement(StyledVerticalPlus, null)));
    }
    return (React.createElement(StyledCountingButton, __assign({ styleType: styleType }, props), icon));
}
export default CountingButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
